import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-label-content',
  standalone: false,
  templateUrl: './label-content.component.html',
})
export class LabelContentComponent {
  @Input() isRequired: boolean;
}
